(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name commons.directive:datePicker
     * @restrict EA
     * @element
     *
     * @description
     *
     * @example
     <example module="commons">
     <file name="index.html">
     <date-picker></date-picker>
     </file>
     </example>
     *
     */
    angular.module('commons')
        .directive('datePicker', datePicker);

    function datePicker(EventManagerService) {
        return {
            restrict: 'E',
            scope: {
                selectedDate: '=',
                datePickerOptions: '=',
                isDisabled: '=',
                dateChange: '&',
                dpRequired: '@',
                dpName:"@"
            },
            templateUrl: function(ele, attributes) {
                if (attributes.isInline==="true"){
                    return 'datepicker.inline.tpl.html';
                }else{
                    return 'datepicker.tpl.html';
                }
            },
            replace: true,
            controllerAs: 'datePicker',
            controller: function () {
                var vm = this;
                vm.name = 'datePicker';
            },
            link: function (scope, element, attrs) {
                /* jshint unused:false */
                /* eslint "no-unused-vars": [2, {"args": "none"}] */
                EventManagerService.registerEventListener(EventManagerService.EVENT.DATEPICKER_OPTIONS_CHANGED, function dpOptionChanged(newOption){
                    var options = picker.datepicker( "option");
                    options = angular.extend(options,newOption);
                    picker.datepicker( "option",  options );
                    picker.datepicker("refresh");
                });

                var settings = {
                    dateFormat : 'dd/mm/yy',
                    firstDay: 1
                };

                if(attrs.isInline === undefined || attrs.isInline!=="true"){
                    settings.buttonImage = "images/calendericon.png";
                    settings.changeMonth = true;
                    settings.changeYear =  true;
                    settings.buttonImageOnly = true;
                    settings.showOn = "button";
                    settings.buttonText = "Select date";
                }
                var opt = settings;
                if (angular.isDefined(attrs.datePickerOptions)){
                    opt = angular.extend(settings,scope.$parent.$eval(attrs.datePickerOptions));
                }

                opt.onSelect = function (dateText) {
                    scope.selectedDate = dateText;
                    var option = {
                        dateText:scope.selectedDate
                    };
                    scope.$apply();
                    scope.dateChange(option);
                };

                scope.$watch('selectedDate', function(newVal, oldVal){
                    picker.datepicker('setDate', newVal);
                    picker.datepicker("refresh");
                });

                scope.$watch('isDisabled', function(newVal, oldVal){
                    picker.datepicker( "option", "disabled", newVal )
                });

                var picker = angular.element(element).datepicker(opt);
                picker.datepicker('setDate', scope.selectedDate);
                picker.on("blur", function(){
                    scope.selectedDate = this.value;
                    scope.$apply();
                    var option = {
                        dateText:scope.selectedDate
                    };
                    scope.dateChange(option);

                });
                picker.datepicker("refresh");

            }
        };
    }
}());
